// Loader animation
document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.x-loader-trigger');
  const loader = document.querySelector('.omaliikku__loader');

  if(buttons) {
    for (let button of buttons) {
      button.addEventListener('click', function() {
        loader.classList.add('active');
      });
    }
  }
});
